import { handleRequest } from "../utilities/requestHandler";

// Server-side paginated: `products` runs to seven figures, so the grid asks for
// one page at a time rather than the whole table.
export const getProducts = ({ page = 0, pageSize = 50, search = "", sortField, sortOrder } = {}) => {
    const params = new URLSearchParams({ page, pageSize });
    if (search) params.set("search", search);
    if (sortField) params.set("sortField", sortField);
    if (sortOrder) params.set("sortOrder", sortOrder);
    return handleRequest("get", `/products?${params.toString()}`);
};

export const createProduct = (productData) =>
    handleRequest("post", "/products/create", productData);

export const updateProduct = (productId, productData) =>
    handleRequest("put", `/products/${productId}`, productData);

export const deleteProducts = (ids) =>
    handleRequest("post", "/products/delete", { ids });

export const uploadProductAssets = (formData) =>
    handleRequest("post", "/products/upload-assets", formData, { 'Content-Type': 'multipart/form-data' });
